module.exports = __webpack_public_path__ + "static/media/internet-of-things07.5e10f8b9.jpg";